import React from 'react';
import { IBaseAppConfig, ITenantAppConfig } from '../providers/types';
const AppConfigContext = () => {
  let context: any;
  return <T extends IBaseAppConfig>(): React.Context<ITenantAppConfig<T>> => {
    if (!context) {
      context = React.createContext<ITenantAppConfig<T>>({});
    }
    return context;
  };
};
export default AppConfigContext();
